import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const brandSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  color: required({ t })(Yup.string())
})

export default brandSchema
